var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta-container"},[_c('div',{staticClass:"cta-heading"},[_vm._v(_vm._s(_vm.title))]),_c('OrangeArrowButton',{staticClass:"cta-button",attrs:{"title":_vm.MAIN_CTA_PARAMS.title,"href":_vm.MAIN_CTA_PARAMS.href}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }